import { Control, Controller, FieldValues, Path, PathValue } from "react-hook-form";
import { CustomInput, CustomInputProps } from "@/components/ui/customs/input";
import { Label } from "@/components/ui/label";
import { useTranslateMessage } from "@/hooks/useTranslateMessage";

interface ControlledInputProps<T extends FieldValues> extends CustomInputProps {
  name: Path<T>;
  control: Control<T>;
  defaultValue?: PathValue<T, Path<T>>;
  label?: string;
  showSuggestion?: boolean;
}

export const ControlledInput = <T extends FieldValues>({
  control,
  name,
  defaultValue,
  label,
  showSuggestion,
  ...props
}: ControlledInputProps<T>) => {
  const translateMessage = useTranslateMessage();
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => (
        <div className="grid w-full items-center gap-1.5">
          {label && <Label htmlFor={name}>{label}</Label>}
          <CustomInput
            {...props}
            id={name}
            value={field.value}
            onChange={field.onChange}
            onBlur={field.onBlur}
            ref={field.ref}
            showsuggestion={showSuggestion}
          />
          {error && <p className="text-sm text-red-500">{translateMessage(error.message)}</p>}
        </div>
      )}
    />
  );
};
